import { badgePrintRecordDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const BADGE_PRINT_RECORDS_PATH = `${WEB_API_PREFIX}/visitor/badge-print-records`;
const VISITS_PATH = `${WEB_API_PREFIX}/visits`;
const recordListSchema = listEnvelopeSchema(badgePrintRecordDTOSchema);
const recordSchema = dataEnvelopeSchema(badgePrintRecordDTOSchema);
export function createBadgePrintRecordsResource(transport) {
    return {
        async list(query) {
            return transport.request({ path: BADGE_PRINT_RECORDS_PATH, query, schema: recordListSchema });
        },
        async reprint(visitId) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${VISITS_PATH}/${encodeURIComponent(visitId)}/badge-reprints`,
                schema: recordSchema,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=badge-print-records.js.map